// frontend-web/src/pages/Student/ScholarshipAttempt.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../api";

export default function ScholarshipAttempt() {
  const { id } = useParams();
  const nav = useNavigate();

  const [exam, setExam] = useState(null);
  const [loading, setLoading] = useState(true);
  const [paying, setPaying] = useState(false);

  useEffect(() => {
    loadExam();
    // eslint-disable-next-line
  }, [id]);

  // ----------------------------
  // LOAD EXAM DETAILS
  // ----------------------------
  const loadExam = async () => {
    try {
      const res = await api.get(`/student/mega-scholarship/${id}`);
      setExam(res.data);
    } catch (err) {
      alert("Failed to load exam details");
    } finally {
      setLoading(false);
    }
  };

  // ----------------------------
  // REGISTER & PAY
  // ----------------------------
  const handleRegisterPay = async () => {
    try {
      setPaying(true);

      const res = await api.post(`/student/mega-scholarship/${id}/register`);
      const { order_id, amount, razorpay_key } = res.data;

      if (!window.Razorpay) {
        alert("Razorpay SDK not loaded. Please refresh.");
        return;
      }

      const options = {
        key: razorpay_key,
        amount,
        currency: "INR",
        order_id,
        name: "EduAt10",
        description: exam.title,

        handler: async function (response) {
          await api.post("/payment/verify", {
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
          });

          alert("✅ Payment successful. Redirecting...");
          setTimeout(() => nav("/user/dashboard"), 1500);
        },
      };

      new window.Razorpay(options).open();
    } catch (e) {
      alert(e?.response?.data?.error || "Payment failed");
    } finally {
      setPaying(false);
    }
  };

  if (loading) return <p style={{ padding: 30 }}>Loading...</p>;
  if (!exam) return <p style={{ padding: 30 }}>Exam not found</p>;

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          {/* ================= HEADER ================= */}
          <div style={headerStyle}>
            <img src="/logo.png" alt="EduAt10" style={logoStyle} />
            <h2 style={titleStyle}>🏆 Scholarship Exam</h2>
          </div>

          {/* ================= EXAM DETAILS ================= */}
          <h3 style={{ marginBottom: 10 }}>{exam.title}</h3>

          <p>📅 <b>Date:</b> {exam.exam_date}</p>
          <p>⏰ <b>Time:</b> {exam.start_time} – {exam.end_time}</p>
          <p>💰 <b>Entry Fee:</b> ₹{exam.entry_fee}</p>

          {/* ================= ACTION ================= */}
          <div style={{ marginTop: 20 }}>
            {exam.is_registered ? (
              <button
                onClick={() => nav(`/student/mega-scholarship/${id}/attempt`)}
                style={btnPrimary}
              >
                ▶ Proceed to Exam
              </button>
            ) : (
              <button
                onClick={handleRegisterPay}
                disabled={paying}
                style={{
                  ...btnPrimary,
                  opacity: paying ? 0.7 : 1,
                }}
              >
                {paying ? "Processing..." : "Register & Pay"}
              </button>
            )}
          </div>

          {/* ================= NAV BUTTONS ================= */}
          <div style={footerBtns}>
            <button
              onClick={() => nav("/user/dashboard")}
              style={btnSecondary}
            >
              ← Dashboard
            </button>

            <button
              onClick={() => nav("/student/scholarship-list")}
              style={btnSecondary}
            >
              ← Exam List
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ================= BACKGROUND ================= */
const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 20,
};

/* ================= CARD ================= */
const cardStyle = {
  maxWidth: 700,
  margin: "auto",
  background: "rgba(255,255,255,0.95)",
  borderRadius: 16,
  padding: 30,
};

/* ================= HEADER ================= */
const headerStyle = {
  textAlign: "center",
  marginBottom: 20,
};

const logoStyle = {
  width: 120,
  marginBottom: 6,
};

const titleStyle = {
  fontSize: 20,
  fontWeight: 800,
};

/* ================= BUTTONS ================= */
const btnPrimary = {
  padding: "10px 22px",
  background: "#02884e",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};

const btnSecondary = {
  padding: "10px 16px",
  background: "#e2e8f0",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};

const footerBtns = {
  marginTop: 30,
  display: "flex",
  gap: 12,
  flexWrap: "wrap",
};
